import { render, staticRenderFns } from "./ReportDetails.vue?vue&type=template&id=2db5107e&scoped=true&"
import script from "./ReportDetails.vue?vue&type=script&setup=true&lang=js&"
export * from "./ReportDetails.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ReportDetails.vue?vue&type=style&index=0&id=2db5107e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db5107e",
  null
  
)

export default component.exports